export enum CancelModalViewState {
    CLOSED,
    SELECT_REASON,
    SAVING,
    ERROR,
}

export const OTHER_OPTION = "Other";
